import { useSearchParams } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { apiHref } from '../lib/api-client';

export function Login() {
  const [searchParams] = useSearchParams();
  const nextPath = searchParams.get('next') ?? '/';
  const loginUrl = apiHref(`/api/auth/login?next=${encodeURIComponent(nextPath)}`);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-4 gap-6">
      <div className="tc-panel p-8 w-full max-w-md">
        <div className="tc-label mb-2">GS Copilot / connexion</div>
        <h1 className="text-2xl font-display tracking-tight mb-3">Connexion</h1>
        <p className="text-sm text-steel-300 leading-relaxed mb-6">
          Utilise ton compte Gaz Systemes pour acceder aux appels d'offres et aux
          outils d'administration autorises.
        </p>

        <a href={loginUrl} className="tc-btn-primary w-full py-3 text-center inline-flex items-center justify-center gap-2">
          <LogIn aria-hidden className="w-4 h-4" strokeWidth={1.75} />
          Se connecter avec Gaz Systemes
        </a>
      </div>

      <div className="text-2xs font-mono text-steel-500 text-center">
        Les comptes et permissions sont geres dans GS.DATA.
      </div>
    </div>
  );
}
